import request from './base/api';

export function fetchParentCategories(cb, errCb) {
  return request({
    url: 'product/parent-categories',
    method: 'get',
    cb,
    errCb
  });
}

export function fetchChildCategories({ parent_id }, cb, errCb) {
  const config = {
    params: {
      parent_id
    }
  };

  return request({
    url: 'product/child-categories',
    method: 'get',
    cb,
    errCb,
    config
  });
}

export function fetchSpecs({ parent_id, product_category_id }, cb, errCb) {
  const config = {
    params: {
      parent_id,
      product_category_id
    }
  };

  return request({
    url: 'product/specs',
    method: 'get',
    cb,
    errCb,
    config
  });
}

export function fetchProducts(
  { member_id, parent_category_id, child_category_id, spec_id, page },
  cb,
  errCb
) {
  const config = {
    params: {
      member_id,
      parent_category_id,
      child_category_id,
      spec_id,
      page
    }
  };
  return request({
    url: 'products',
    method: 'get',
    cb,
    errCb,
    config
  });
}

export function fetchProduct({ member_id, id, branch_id }, cb, errCb) {
  const config = {
    params: {
      member_id,
      branch_id
    }
  };
  return request({
    url: `products/${id}`,
    method: 'get',
    cb,
    errCb,
    config
  });
}

export default {
  fetchParentCategories,
  fetchChildCategories,
  fetchSpecs,
  fetchProducts,
  fetchProduct
};
